import React from 'react';
import { Space } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

export const PasswordRequirements = ({password, ...props}) => {

    const checkMark = <CheckOutlined style={{color: 'var(--success-color)'}}/>;
    const errorMark = <CloseOutlined style={{color: 'var(--error-color)'}}/>;

    return (
        <>
            <ul style={{margin: '10px 0', listStyle: 'none'}}>
                <li><Space>{password ? (password.length >= 12 && password.length <= 30 ? checkMark : errorMark ) : errorMark }12-30 characters long</Space></li>
                <li><Space>{/[A-Z]/.test(password) ? checkMark : errorMark }At least 1 uppercase character</Space></li>
                <li><Space>{/[a-z]/.test(password) ? checkMark : errorMark }At least 1 lowercase letter</Space></li>
                <li><Space>{/[0-9]/.test(password) ? checkMark : errorMark }At least 1 numeral [0-9]</Space></li>
                <li><Space>{/[!@#$%^&*]/.test(password) ? checkMark : errorMark }At least 1 special character [!@#$%^&*]</Space></li>
            </ul>
        </>
    )
}

PasswordRequirements.defaultProps = {
    password: '',
}